import { configureStore } from '@reduxjs/toolkit';

import rootReducer, { RootState } from './reducers';

const configure = (initialState?: RootState) =>
  configureStore({
    reducer: rootReducer,
    devTools: true,
    ...(initialState ? { initialState } : {}),
  });

export default configure;
